import { render, staticRenderFns } from "./queryHeader.vue?vue&type=template&id=ac0f15f4&scoped=true"
import script from "./queryHeader.vue?vue&type=script&lang=js"
export * from "./queryHeader.vue?vue&type=script&lang=js"
import style0 from "./queryHeader.vue?vue&type=style&index=0&id=ac0f15f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0f15f4",
  null
  
)

export default component.exports